import { Box, Select, type SelectProps } from "@prismicio/editor-ui"

import {
  RequestFormInputBase,
  type RequestFormInputBaseProps,
} from "./RequestFormInputBase"

export function RequestFormSelect(
  props: Pick<RequestFormInputBaseProps, "label"> & SelectProps<string>,
) {
  const { label, children, ...selectProps } = props

  return (
    <RequestFormInputBase label={label}>
      <Box minWidth={0}>
        <Select
          color="grey"
          size="medium"
          side="bottom"
          flexContent
          endIcon="unfoldMore"
          sx={{ width: "100%" }}
          {...selectProps}
        >
          {children}
        </Select>
      </Box>
    </RequestFormInputBase>
  )
}
